import { z } from 'zod/v4'
import { AgentRunContextSchema } from '../resources/types'

export const SandboxScenarioSchema = z.object({
  label: z.string().optional(),
  context: AgentRunContextSchema,
})

export const SandboxConfigSchema = z.object({
  enabled: z.boolean().optional(),
  /** @deprecated Use 'context' instead of 'mockContext' */
  mockContext: AgentRunContextSchema.optional(),
  context: AgentRunContextSchema.optional(),
  scenarios: z.record(z.string(), SandboxScenarioSchema).optional(),
  defaultScenario: z.string().optional(),
})

export type SandboxConfig = z.infer<typeof SandboxConfigSchema>
